import { useIsValidProviderAndPatientQuery } from '../generated/graphql';

import { gql } from '@apollo/client';

export const IS_VALID_PROVIDER_AND_PATIENT_QUERY = gql`
  query IsValidProviderAndPatient($providerShortId: ID!, $patientShortId: ID!) {
    isValidProviderAndPatient(providerShortId: $providerShortId, patientShortId: $patientShortId)
  }
`;

export function useIsValidProviderAndPatient(providerShortId: string, patientShortId: string) {
  return useIsValidProviderAndPatientQuery({
    variables: { providerShortId, patientShortId },
    context: { skipAuth: true },
  });
}
